// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3e9cB","topSticker":"_34SEz","heading":"_3D8QH","cardContainer":"_1WIUr","knowMoreWrap":"_1WEJs","knowMore":"_23rL9"};